var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNochat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.668,
    height: 23.173,
    viewBox: "0 0 23.668 23.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-112.455 -414.488)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4c27664d",
    d: "M2146.369,642.6v13.347l3.8,1.257.877,4.062,5.457-4.062,11.444-.717s.792-7.243-2.28-7.243c-1.9-.22-6.827-1.227-6.827-5.053,0-4.931-10.289-2.6-11.664-2.245S2146.369,642.6,2146.369,642.6Z",
    transform: "translate(-2033 -225)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2633.545 440.463)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M310.447,64.3h-2.4V61.9a.873.873,0,1,0-1.746,0v2.4h-2.4a.873.873,0,0,0,0,1.746h2.4v2.4a.873.873,0,1,0,1.746,0v-2.4h2.4a.873.873,0,0,0,0-1.746Z",
    transform: "translate(2457.472 -87)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2746 -24.824)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M5.344,197.918a.694.694,0,0,0,.281.055.724.724,0,0,0,.491-.2l4.891-4.681h9.2a3.466,3.466,0,0,0,3.464-3.464v-5.219a.71.71,0,0,0-1.42,0v5.219a2.046,2.046,0,0,1-2.044,2.044H10.719a.724.724,0,0,0-.491.2l-3.9,3.729v-3.206a.712.712,0,0,0-.71-.71H3.464a2.046,2.046,0,0,1-2.044-2.044V179.421a2.053,2.053,0,0,1,2.044-2.052h8.371a.71.71,0,0,0,0-1.42H3.464A3.466,3.466,0,0,0,0,179.414v10.219A3.466,3.466,0,0,0,3.464,193.1H4.915v4.174A.708.708,0,0,0,5.344,197.918Z",
    transform: "translate(0 -175.95)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNochat);
export default __webpack_public_path__ + "static/media/nochat.52adc44cfb7cc5ac38d8f8bd0a3a67ef.svg";
export { ForwardRef as ReactComponent };